<template>
    <div>
        <div v-if="mode=='product' && !isProductInBasket()" >
            <div class="detail_count">
                <button class="detail_count-minus" @click="decrement()"></button>
                <div class="detail_count-value">{{ count }}</div>
                <button class="detail_count-plus"  @click="increment()"></button>
            </div>
            <div class="detail_buts" >
                <a href="javascript:void(0)" @click="addToBasket" class="detail_but-left btn-orange"> <i class="icon-cart"></i> Добавить в корзину </a>
                <a href="javascript:void(0)" @click="quickOrder" class="detail_but-right btn-gray"  >Купить в 1 клик </a>
            </div>
        </div>
        <div v-if="mode=='product' && isProductInBasket()" >
            <div class="detail_buts" >
                <a href="/customer/basket"  class="detail_but-left btn-orange"> Уже в корзине. Оформить заказ </a>
            </div>
        </div>
        <div class="slider_item_buts" v-if="mode=='slider' && !isProductInBasket()">
            <a href="javascript:void(0)" @click="addToBasket" class="btn-orange"><i class="icon-cart"></i> В корзину </a>
            <a href="javascript:void(0)" @click="quickOrder" class="btn-gray"> Купить в 1 клик </a>
        </div>
        <div v-if="mode=='slider' && isProductInBasket()"  class="slider_item_buts" >
          <a href="/customer/basket"  class="detail_but-left btn-orange"> Оформить заказ </a>
          <a href="javascript:void(0)" @click="quickOrder" class="btn-gray"> Купить в 1 клик </a>
        </div>
        <div class="catList_item_buts" v-if="mode=='catalog' && !isProductInBasket()">
            <a href="javascript:void(0)" @click="addToBasket"  class="btn-orange"> <i class="icon-cart"></i> В корзину </a>
            <a href="javascript:void(0)" @click="quickOrder" class="btn-gray"> Купить в 1 клик </a>
        </div>
        <div class="catList_item_buts" v-if="mode=='catalog' && isProductInBasket()">
          <a href="/customer/basket"  class="btn-orange">  Оформить заказ </a>
          <a href="javascript:void(0)" @click="quickOrder" class="btn-gray"> Купить в 1 клик </a>
        </div>
        <div class="slider_item_buts" v-if="mode=='external'">
          <a href="javascript:void(0)" @click="goToLink('site')" class="btn-external btn-ishop"><img src="/images/magaz.png"></a>
          <a href="javascript:void(0)" @click="goToLink('ozon')" class="btn-external btn-ozon"><img src="/images/ozon.png"></a>
          <a href="javascript:void(0)" @click="goToLink('wb')" class="btn-external btn-wb"><img src="/images/wb.png"> </a>
        </div>
    </div>
</template>

<script>
    import QuickOrder from "./QuickOrder";

    export default {
        name: 'BuyButton',
        props: ['product', 'mode'],
        data () {
          return {
              count: 1
          }
        },
        methods: {
            goToLink (type) {
              switch(type){
                case 'site':
                  window.ym(39587615,'reachGoal','promo_site')
                  if(this.product.additional_params?.exteranl_button_links?.site){
                    window.location.href=this.product.additional_params.exteranl_button_links.site
                  }else{
                    alert('Не указана ссылка');
                  }
                  break;
                case 'wb':
                  window.ym(39587615,'reachGoal','promo_wb')
                  if(this.product.additional_params?.exteranl_button_links?.wb){
                    window.location.href=this.product.additional_params.exteranl_button_links.wb
                  }else{
                    alert('Не указана ссылка');
                  }
                  break;
                case 'ozon':
                  window.ym(39587615,'reachGoal','promo_ozon')
                  if(this.product.additional_params?.exteranl_button_links?.ozon){
                    window.location.href=this.product.additional_params.exteranl_button_links.ozon
                  }else{
                    alert('Не указана ссылка');
                  }
                  break;
              }
            },
            addToBasket () {
                this.product.count = this.count
                this.$store.commit('addToBasket', this.product);
                this.$modal.show('dialog', {
                    title: 'Товар добавлен в корзину',
                    text: this.product.name + (this.count > 1 ? ', ' + this.count + ' шт.' : ''),
                    buttons: [
                        {
                            title: 'Перейти в корзину',
                            handler: () => {
                                window.location.href = '/customer/basket';
                            }
                        },
                        {
                            title: 'Закрыть'
                        }
                    ]
                })
                window.ym(39587615,'reachGoal','click.basket')
            },
            quickOrder () {
                this.$modal.show(QuickOrder, {
                    product: this.product
                },{
                    height: 'auto'
                })
                window.ym(39587615,'reachGoal','click.quick.order')
            },
            increment () {
                if(this.product.base_stock.cnt > this.count) {
                    this.count++;
                }
            },
            decrement () {
                if(this.count > 1) {
                    this.count--;
                }
            },
            isProductInBasket () {
              return this.$store.state.basket.find(basketItem => basketItem.id === this.product.id)
            }
        },
        mounted: function () {

        },
    }
</script>

<style scoped>
  .btn-external {
    width: 33%!important;
    text-align: center;
  }
  .btn-external img {
    padding: 10%;
    width: 80%;
    display: inline;
  }
  .btn-external:last-child {
    width: 34%!important;
  }

  .btn-ishop {
    background: #a91b39!important;

  }
  .btn-ozon {
    background: #0259ff!important;

  }
  .btn-wb {
    background: #9d328a!important;

  }
</style>